import { Button } from "@/components/ui/button";
import heroImage from "@/assets/hero-dock-autonomy.jpg";
import ContactDialog from "@/components/ContactDialog";
import DemoDialog from "@/components/DemoDialog";
import { useRef, useEffect, useState } from "react";

const Hero = () => {
  // const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Force video play for mobile devices
    const playVideo = async () => {
      try {
        video.muted = true;
        video.playsInline = true;
        video.defaultMuted = true;
        await video.play();
      } catch (error) {
        console.log('Video autoplay failed:', error);
      }
    };

    // Try to play immediately
    playVideo();

    // Also try to play on user interaction
    const handleUserInteraction = () => {
      playVideo();
      document.removeEventListener('touchstart', handleUserInteraction);
      document.removeEventListener('click', handleUserInteraction);
    };

    document.addEventListener('touchstart', handleUserInteraction);
    document.addEventListener('click', handleUserInteraction);

    return () => {
      document.removeEventListener('touchstart', handleUserInteraction);
      document.removeEventListener('click', handleUserInteraction);
    };
  }, []);

  // Reusable Button component with shared styles
  const ButtonStyle = "px-6 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-bold transition-all duration-200 transform hover:scale-105";

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <video 
          ref={videoRef}
          autoPlay 
          muted 
          loop 
          playsInline 
          preload="auto" 
          className="w-full h-full object-cover"
        >
          <source src="https://cdn.vegamrobotics.com/uploads/Autodock_Hero_Bg.mp4" type="video/mp4" />
        </video>

        <div className="absolute inset-0 bg-gradient-to-r from-background/80 via-background/50 to-background/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-background/10"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 xl:gap-20 items-center">
          <div className="space-y-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground animate-fade-in-up drop-shadow-lg leading-tight">
              The AutoDock: 
              <span className="text-primary block animate-slide-in-left text-2xl sm:text-3xl md:text-4xl">Smart Docks. Smarter Factory.</span>
            </h1>
            
            <p className="text-lg sm:text-xl md:text-2xl text-foreground/90 max-w-2xl animate-fade-in drop-shadow-md" style={{
              animationDelay: '0.3s',
              animationFillMode: 'both'
            }}>
              "Transforming Dock-to-Stock Operations, Powered by Vegam's 20-Year Legacy in Manufacturing and Digital Factory Innovation."
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 pt-4 animate-fade-in" style={{
              animationDelay: '0.6s',
              animationFillMode: 'both'
            }}>
              {/* List items here... */}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 pt-4 animate-fade-in" style={{
              animationDelay: '0.9s',
              animationFillMode: 'both'
            }}>
              <ContactDialog>
                <Button size="lg" className={`bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl hover:shadow-2xl ${ButtonStyle}`}>
                  Contact Us
                </Button>
              </ContactDialog>
              <Button 
                variant="outline" 
                size="lg" 
                className={`border-2 border-foreground/80 bg-background/20 backdrop-blur-sm text-foreground hover:bg-foreground hover:text-background shadow-lg ${ButtonStyle}`}
                onClick={() => window.open('https://www.youtube.com/watch?v=_xaQR0S4I7Y', '_blank', 'noopener,noreferrer')}
              >
                Watch Demo
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* {showScrollIndicator && (
        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
          <div className="flex flex-col items-center space-y-2 transition-all duration-500 hover:scale-110 cursor-pointer animate-bounce" onClick={() => {
            const nextSection = document.querySelector('#our-journey-section');
            nextSection?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }}>
            <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white">
              <span className="text-xl">&darr;</span>
            </div>
            <span className="text-white text-sm">Scroll Down</span>
          </div>
        </div>
      )} */}
    </section>
  );
};

export default Hero;

